import { z } from "zod";
import { adminCountSchema, adminDaySchema, adminMicrosSchema, adminPageQuerySchema, adminRecordedSchema, } from "./common.js";
import { adminCustomerUsageSchema } from "./usage.js";
/** Every role a membership or an invite can carry, as the database holds them. */
const membershipRoleSchema = z.enum(["owner", "admin", "member", "viewer"]);
export const customerFilterSchema = z.enum([
    "all",
    "active",
    "setup",
    "dormant",
    "over_quota",
]);
export const customerSortSchema = z.enum([
    "name",
    "spend",
    "questions",
    "created",
    "active",
    "people",
]);
export const customerQuerySchema = adminPageQuerySchema.extend({
    search: z.string(),
    filter: customerFilterSchema,
    sort: customerSortSchema,
    direction: z.enum(["asc", "desc"]),
});
export const customerRowSchema = z.object({
    workspaceId: z.string(),
    name: z.string(),
    ownerEmail: z.string(),
    createdAt: z.string(),
    members: adminCountSchema,
    brands: adminCountSchema,
    reports: adminCountSchema,
    questions: adminCountSchema,
    quota: adminCountSchema,
    spendMonthUsdMicros: adminMicrosSchema,
    state: z.enum(["active", "setup"]),
    capturesPaused: z.boolean(),
    lastActiveAt: adminRecordedSchema(z.string()),
    /** Distinct people `usage_events` saw here in the last 7 days. */
    peopleThisWeek: adminCountSchema,
});
export const customerListSchema = z.object({
    /** The moment the answer describes; relative times are counted from it. */
    asOf: z.string(),
    total: adminCountSchema,
    /** How many each filter would show, so the chips can say so before a click. */
    counts: z.record(customerFilterSchema, adminCountSchema),
    rows: z.array(customerRowSchema),
});
export const customerDetailSchema = customerRowSchema.extend({
    asOf: z.string(),
    /** Runs of this workspace with no outcome and no job that will pick them up. */
    stuckRuns: adminCountSchema,
    signupMethod: adminRecordedSchema(z.enum(["google", "invite", "password", "magic_link"])),
    members: z.array(z.object({
        name: z.string(),
        email: z.string(),
        role: membershipRoleSchema,
        joinedAt: z.string(),
        /** Null: not used here since usage began to be recorded. */
        lastUsedAt: z.string().nullable(),
    })),
    reports: z.array(z.object({
        brand: z.string(),
        domain: z.string(),
        active: z.boolean(),
        questions: adminCountSchema,
    })),
    invites: z.array(z.object({
        email: z.string(),
        role: membershipRoleSchema,
        sentAt: z.string(),
        state: z.enum(["pending", "accepted", "expired", "revoked"]),
    })),
    spend: z.array(z.object({ day: adminDaySchema, usdMicros: adminMicrosSchema })),
    outcomes: z.array(z.object({ day: adminDaySchema, success: adminCountSchema, other: adminCountSchema })),
    usage: adminCustomerUsageSchema,
});
/** What an action changed, so the toast can say it and offer to undo it. */
export const customerChangeSchema = z.object({
    workspaceId: z.string(),
    name: z.string(),
    action: z.enum(["quota", "pause", "requeue"]),
    previous: z.number().int(),
    current: z.number().int(),
});
//# sourceMappingURL=customers.js.map